<div id="mapCanvas" *ngIf="accomodation">
  <div class="map">
    <google-map
      [width]="'auto'"
      [height]="420"
      [zoom]="5"
      [center]="{lat: accomodation.lat, lng: accomodation.lng}">
      <map-marker
        [title]="accomodation.name"
        [label]="accomodation.name"
        [position]="{lat: accomodation.lat, lng: accomodation.lng}">
      </map-marker>
    </google-map>
  </div>
</div>
<div class="map-detail" *ngIf="accomodation?.positions.length > 0">
  <h5>Informazioni sulla posizione</h5>
  <ul>
    <li *ngFor="let position of accomodation.positions">{{position.name}}</li>
  </ul>
</div>
